import HeroSection from './HeroSection';
import './HeroSection.scss';

export default HeroSection;
